import { combineReducers } from 'redux';

import specifiedPools from './specifiedPools.reducer';
import trades from './trades.reducer';

const reducer = combineReducers({ trades, specifiedPools });

export default reducer;
